import React from 'react';
import SVG from 'react-inlinesvg';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Dialog, CircularProgress } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import PropTypes from 'prop-types';

import IconEmail from '../../../../../../assets/icons/Email.svg';
import IconTeste from '../../../../../../assets/icons/LaptopMobile.svg';
import SliderImage from '../SliderImage';
import useStyles from './styles';

export function CardLocker({
  open,
  devolutionPageConfigs,
  handleClose,
  lockerData,
  onLockerSelected,
  currentLocation,
  buttonText,
  loading,
}) {
  const classes = useStyles(devolutionPageConfigs);
  const [expandedHours, setExpandedHours] = React.useState('');
  const [expandedSize, setExpandedSize] = React.useState('');
  const lockerAddress =
    lockerData &&
    `${lockerData.street}, ${lockerData.number} - ${lockerData.city}, ${lockerData.state} CEP: ${lockerData.zipCode}`;

  const handleChangeOpenHours = () => {
    setExpandedHours(!expandedHours);
  };
  const handleChangeOpenSize = () => {
    setExpandedSize(!expandedSize);
  };
  const selectLocker = () => {
    onLockerSelected(lockerAddress, lockerData.boxCode, lockerData.name);
  };

  const howToGetThereUrl = `https://www.google.com/maps?saddr=${
    currentLocation ? currentLocation?.lat + ',' + currentLocation?.lng : ''
  }&daddr=${lockerData ? lockerData?.lat + ',' + lockerData?.lng : ''}`;

  return (
    <Dialog className={classes.dialog} onClose={handleClose} open={open}>
      <Card className={classes.card}>
        <button
          type="button"
          className={classes.buttonClose}
          onClick={handleClose}
        >
          X
        </button>
        <CardMedia className={classes.media}>
          <SliderImage images={lockerData && lockerData.images} />
        </CardMedia>
        <CardContent className={classes.cardContent}>
          <Card className={`${classes.cardInfo} ${classes.marginTop_50}`}>
            <div className={classes.rowContent}>
              <div className={classes.col}>
                <strong className={classes.titleName}>{lockerData.name}</strong>
                <span className={classes.text}>{lockerData.boxCode}</span>
              </div>
            </div>
            <div className={classes.rowContent}>
              <SVG className={classes.iconSVG} src={IconEmail} width={27} />
              <span className={classes.text}>{lockerAddress}</span>
            </div>
            <div className={classes.rowContent}>
              <SVG className={classes.iconSVG} src={IconTeste} width={24} />
              <span className={classes.text}>Telefone: 0800-887-16-44</span>
            </div>

            <Accordion
              className={classes.accordion}
              expanded={expandedHours}
              onChange={handleChangeOpenHours}
            >
              <AccordionSummary
                className={classes.accordionSummary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <SVG className={classes.iconSVG} src={IconTeste} width={24} />
                <span className={classes.text}>Horário de funcionamento</span>
              </AccordionSummary>
              <AccordionDetails>
                <Card className={classes.cardInfoHours}>
                  {lockerData &&
                    lockerData.businessHours.map((item) => {
                      return (
                        <div
                          key={item.name}
                          className={`${classes.rowContent} ${classes.justifyBetween}`}
                        >
                          <span className={classes.text}>{`${item.day}`}:</span>
                          <span
                            className={classes.text}
                          >{`${item.start} - ${item.end}`}</span>
                        </div>
                      );
                    })}
                </Card>
              </AccordionDetails>
            </Accordion>
            <Accordion
              className={classes.accordion}
              expandIcon={<ExpandMoreIcon />}
              expanded={expandedSize}
              onChange={handleChangeOpenSize}
            >
              <AccordionSummary
                className={classes.accordionSummary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <SVG className={classes.iconSVG} src={IconTeste} width={24} />
                <span className={classes.text}>
                  Dimensões dos compartimentos
                </span>
              </AccordionSummary>
              <AccordionDetails>
                <div className={classes.tableContent}>
                  <div className={classes.tableRow}>
                    <div className={classes.tableItem}>Compartimento</div>
                    <div className={classes.tableItem}>Largura</div>
                    <div className={classes.tableItem}>Altura</div>
                    <div className={classes.tableItem}>Profundidade</div>
                  </div>
                  {lockerData.compartimentType &&
                    lockerData.compartimentType.map((type) => (
                      <div className={classes.tableRow}>
                        <div className={classes.tableItem}>{type.type}</div>
                        <div className={classes.tableItem}>{type.width}</div>
                        <div className={classes.tableItem}>{type.height}</div>
                        <div className={classes.tableItem}>{type.depth}</div>
                      </div>
                    ))}
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
          <a
            className={classes.howToGoButton}
            href={howToGetThereUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Como chegar?
          </a>
          <button
            type="button"
            className={classes.buttonNextStep}
            onClick={selectLocker}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              buttonText
            )}
          </button>
        </CardContent>
      </Card>
    </Dialog>
  );
}

const lockerDatahape = {
  additionalInfo: PropTypes.string,
  boxCode: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  district: PropTypes.string.isRequired,
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  street: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
  bussinessHours: PropTypes.arrayOf(PropTypes.string).isRequired,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
};

CardLocker.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  lockerData: PropTypes.objectOf(PropTypes.shape(lockerDatahape)).isRequired,
  onClick: PropTypes.func.isRequired,
};
